__turbopack_context__.v({
  "acheivername": "contact-us-module__B5vILa__acheivername",
  "acheivername2": "contact-us-module__B5vILa__acheivername2",
  "acheiverrank": "contact-us-module__B5vILa__acheiverrank",
  "captcha": "contact-us-module__B5vILa__captcha",
  "checkboxcontent": "contact-us-module__B5vILa__checkboxcontent",
  "contactbox": "contact-us-module__B5vILa__contactbox",
  "contactboxheight": "contact-us-module__B5vILa__contactboxheight",
  "contactsubcontent": "contact-us-module__B5vILa__contactsubcontent",
  "img": "contact-us-module__B5vILa__img",
  "imgboxbelow": "contact-us-module__B5vILa__imgboxbelow",
  "invalidCheck2": "contact-us-module__B5vILa__invalidCheck2",
  "mobilemaillinks": "contact-us-module__B5vILa__mobilemaillinks",
  "normalbutton": "contact-us-module__B5vILa__normalbutton",
  "pagemaintitle": "contact-us-module__B5vILa__pagemaintitle",
  "redunderline": "contact-us-module__B5vILa__redunderline",
  "sectiontitle": "contact-us-module__B5vILa__sectiontitle",
});
